export const IT_INVENTORY_TABS = {
  LAPTOPS: 'laptops',
  MOBILES: 'mobiles',
  SERVERS: 'servers',
  CLOUD: 'cloud',
  CODE: 'code',
  HARDWARE: 'hardware',
} as const

export type IItInventoryTab = (typeof IT_INVENTORY_TABS)[keyof typeof IT_INVENTORY_TABS]

// Enrolment is what the MDM column reports: unmanaged means the host is absent from the MDM host list.
export const IT_INVENTORY_MDM_STATE = {
  ONLINE: 'online',
  OFFLINE: 'offline',
  UNMANAGED: 'unmanaged',
  // Enrolled with the MDM profile, but the MDM agent is not installed
  NO_AGENT: 'no_agent',
  // Fleet did not answer, so enrolment is unknown rather than absent.
  UNAVAILABLE: 'unavailable',
} as const

export type IItInventoryMdmState = (typeof IT_INVENTORY_MDM_STATE)[keyof typeof IT_INVENTORY_MDM_STATE]

// A host's verdict on its five hardening checks, read from MDM's CIS benchmark or, without MDM, from the EDR.
export const IT_INVENTORY_PROFILE_COMPLIANCE = {
  PASS: 'pass',
  FAIL: 'fail',
  // Nothing failed, but not every check has a reading to call it a pass.
  NOT_APPLICABLE: 'not_applicable',
} as const

export type IItInventoryProfileCompliance =
  (typeof IT_INVENTORY_PROFILE_COMPLIANCE)[keyof typeof IT_INVENTORY_PROFILE_COMPLIANCE]
